import Vue from 'vue'
import VueRouter from 'vue-router'
import Query from '../components/query.vue'
import GenerateLink from '../components/generateLink.vue'
import ErrorPage from '../components/errorPage.vue'


Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: "/generateLink" },
  {
    path: '/generateLink', component: GenerateLink, name: 'GenerateLink', meta: {
      title: '查询链接生成'
    }
  },
  {
    path: '/query', component: Query, name: 'Query', meta: {
      title: '赛事成绩查询'
    }
  },
  {
    path: '/errorPage', component: ErrorPage, name: 'ErrorPage', meta: {
      title: '页面不存在'
    }
  }
]

const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location){
//   return originalPush.call(this,location).catch(err => err)
// }


const router = new VueRouter({
  routes
})

export default router
